/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
//import Modal from 'react-responsive-modal';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class MemberShipPayEnd extends Component {
  state = {
    //orderCode: this.props.childProps.orderCode
  };
  componentWillMount = () => {
    this._getOrder();
  };
  _getOrder = async () => {
    const orderCode = this.props.childProps.orderCode;
    if (orderCode === undefined || orderCode === null || orderCode === '') {
      toast.error('주문번호가 누락되었습니다.');
    } else {
      const result = await this._getOrderApi(orderCode);
      const intReturn = result.data[0].intReturn;
      const payData = result.data[0].listData;
      if (intReturn === 0) {
        this.setState({
          payData,
        });
      }
    }
  };
  _getOrderApi = (orderCode) => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/payResult', {
        params: {
          orderCode: orderCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _onStart = () => {
    const { history, setMemberShipPayEnd } = this.props;
    setMemberShipPayEnd(false, '');
    history.push('/');
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onClose = () => {
    const { history, setMemberShipPayEnd } = this.props;
    setMemberShipPayEnd(false, '');
    history.push('/');
  };
  _onMyCash = () => {
    const { history, setMemberShipPayEnd } = this.props;
    setMemberShipPayEnd(false, '');
    history.push('/mypage/3');
  };
  render() {
    const { payData } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="cashcard_pop" style={{ zIndex: 10000001 }}>
          <div className="cashcard_close">
            <a style={{ cursor: 'pointer' }} onClick={this._onClose}>
              닫기
            </a>
          </div>
          {payData ? (
            <Fragment>
              <div
                className={
                  payData[0].freePassSerial === 9 ||
                  payData[0].freePassSerial === 10
                    ? 'cashcard_pop_layer2'
                    : 'cashcard_pop_layer2'
                }
              >
                <div
                  className={
                    payData[0].freePassSerial === 9 ||
                    payData[0].freePassSerial === 10
                      ? 'cashcard_pop_top2'
                      : 'cashcard_pop_top2'
                  }
                >
                  <div className="member03">
                    {/*맞는 이미지로 교체*/}
                    {payData[0].freePassSerial === 9 ? (
                      <img src={imgUrl + '/img/cashcard/member01.png'} />
                    ) : payData[0].freePassSerial === 10 ? (
                      <img src={imgUrl + '/img/cashcard/member02.png'} />
                    ) : (
                      <Fragment>
                        <div className="member02">
                          <div className="cashcard_box_top"></div>
                          <div className="cashcard_box">
                            <h1 style={{ fontSize: 24, color: '#fff' }}>
                              {/*payData[0].freePassSerial === 56 ? '프리미엄' : payData[0].freePassSerial === 55 ? '골드' : '실버' */}
                              <span>{payData[0].freePassName}</span>
                            </h1>
                            {/*<div className="cashcard_box_barcode"><img src="img/cashcard/barcode.jpeg"/><span>포인트 충전</span></div>*/}
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </div>
                  <div className="evn_bg">
                    <img src={imgUrl + '/img/cashcard/pop_bg.png'} />
                  </div>
                </div>

                <div className="cashcard_pop_content">
                  {/*<h2>결제정보</h2>*/}
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                    className="cashcard_pop_table1"
                  >
                    <tbody>
                      <tr>
                        <th>이름</th>
                        <td>{payData[0].username}</td>
                      </tr>
                      <tr>
                        <th>핸드폰</th>
                        <td>{payData[0].mobile}</td>
                      </tr>
                      <tr>
                        <th>이메일</th>
                        <td>{payData[0].email}</td>
                      </tr>
                      <tr>
                        <th>이용권</th>
                        <td>{payData[0].freePassName}</td>
                      </tr>
                      <tr>
                        <th>결제정보</th>
                        <td>{payData[0].payName}</td>
                      </tr>
                      <tr>
                        <th>결제일</th>
                        <td>{payData[0].regDate}</td>
                      </tr>
                      <tr>
                        <th>결제금액</th>
                        <td>{this._CommaFormatted(payData[0].price)}원</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="cashcard_pop_line"></div>
                  {/*정기결제 시만....*/}
                  {payData[0].freePassSerial === 9 ? (
                    <Fragment>
                      <div className="cashcard_pop_text">
                        {/*멘트 변경*/}
                        {payData[0].freeFlag > 0 ? (
                          <Fragment>
                            {payData[0].payType === 'SC0010' ? (
                              <strong>
                                멤버십 정기결제가 시작되었습니다. 최초 1회에
                                한해서 한달동안 무료로 제공됩니다.(이후 정상
                                과금 됨)
                              </strong>
                            ) : (
                              <strong>
                                멤버십 정기결제가 시작되었습니다. 최초 1회에
                                한해서 한달동안 500원 결제로 제공됩니다.(이후
                                정상 과금 됨)
                              </strong>
                            )}
                            <span>무료이용 종료</span> 전에 멤버십을 해지시
                            요금이 청구되지 않으며
                            <br />
                            멤버십을 해지하시지 않으면 자동으로
                            연장(과금)됩니다.
                            <br />
                            해지 및 변경을 원하시면 <span>마이페이지</span> 로
                            이동해 변경을 클릭하세요.
                          </Fragment>
                        ) : (
                          <Fragment>
                            <strong>
                              멤버십 정기 결제가 정상적으로 완료되었습니다.
                            </strong>
                            <span>멤버십 이용 종료</span> 전에 멤버십을 해지시
                            요금이 청구되지 않으며
                            <br />
                            멤버십을 해지하시지 않으면 자동으로
                            연장(과금)됩니다.
                            <br />
                            해지 및 변경을 원하시면 <span>마이페이지</span> 로
                            이동해 변경을 클릭하세요.
                          </Fragment>
                        )}
                      </div>
                      <a style={{ cursor: 'pointer' }} onClick={this._onStart}>
                        작품관람 시작하기
                      </a>
                    </Fragment>
                  ) : payData[0].freePassSerial === 10 ? (
                    <Fragment>
                      <div className="cashcard_pop_text">
                        {/*멘트 변경*/}
                        <strong>멤버십 3개월 결제가 완료 되었습니다. </strong>
                        <span>애니플러스</span>의 모든 컨텐츠를 무제한 즐겨
                        보세요
                        <br />
                        해지 및 변경을 원하시면 <span>마이페이지</span> 로
                        이동해 변경을 클릭하세요.
                      </div>
                      <a style={{ cursor: 'pointer' }} onClick={this._onStart}>
                        작품관람 시작하기
                      </a>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <p>
                        포인트는 애니플러스가 제공하고 있는 다양한 서비스에서
                        현금처럼 <br />
                        사용가능한 재화입니다.
                      </p>
                      <p>
                        포인트는 애니플러스가 제공하는 결제 수단에 따라 충전할
                        수 있으며, <br />
                        다른 결제 수단과 병행하여 사용 가능합니다.
                      </p>
                      <p>
                        포인트는 행사/타이틀/상품 등에 따라 포인트 사용이 불가할
                        수 있습니다.
                      </p>
                      <a style={{ cursor: 'pointer' }} onClick={this._onMyCash}>
                        충전내역 확인하기
                      </a>
                    </Fragment>
                  )}
                </div>
              </div>
            </Fragment>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MemberShipPayEnd));
